import styled from 'styled-components';
import GraphEmptyState from '../../../ResourceAllocationOverview/EmptyState/GraphEmptyState';

export const StyledEmptyStateAdjustFilters = styled.div``;

const EmptyStateAdjustFilters = () => {
  return (
    <StyledEmptyStateAdjustFilters>
      <GraphEmptyState desc='Try adjusting your filters' />
    </StyledEmptyStateAdjustFilters>
  );
};

export default EmptyStateAdjustFilters;
